import React, { useState } from "react";
import { motion } from "framer-motion";
import GlassCard from "./GlassCard";

const CertificationCard = ({ certification, onClick }) => {
    const { title, issuer, issue_date, image_url } = certification;
    const [isHovered, setIsHovered] = useState(false);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("es-ES", { year: "numeric", month: "short" });
    };

    return (
        <GlassCard
            onClick={onClick}
            hoverAnimation={{ y: -4 }}
            showOverlay={false}
            onHoverStart={() => setIsHovered(true)}
            onHoverEnd={() => setIsHovered(false)}
            className="flex-shrink-0 w-full cursor-pointer h-full flex flex-col items-center py-4"
        >
            {/* Imagen circular */}
            <div className="relative mb-4 mt-2">
                <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto rounded-full overflow-hidden border-4 border-gray-200/50 dark:border-gray-700/50 shadow-lg group-hover:shadow-xl group-hover:border-blue-400/70 dark:group-hover:border-blue-500/70 transition-all duration-300">
                    <motion.div
                        animate={{
                            scale: isHovered ? 1.1 : 1,
                        }}
                        transition={{ duration: 0.4, ease: "easeOut" }}
                        className="w-full h-full"
                    >
                        {image_url ? (
                            <img src={image_url} alt={title} className="w-full h-full object-cover" />
                        ) : (
                            <div className="w-full h-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                                <span className="text-4xl sm:text-5xl">🎓</span>
                            </div>
                        )}
                    </motion.div>
                </div>
            </div>

            {/* Info */}
            <div className="text-center px-1 sm:px-2 flex flex-col">
                <h3 className="text-xs sm:text-sm font-bold text-gray-900 dark:text-white mb-2 line-clamp-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300">
                    {title}
                </h3>

                <div className="w-8 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full mx-auto mb-2 opacity-60 group-hover:w-16 group-hover:opacity-100 transition-all duration-500" />

                <p className="text-xs text-gray-600 dark:text-gray-400 mb-1 font-medium">{issuer}</p>
                <p className="text-xs text-gray-500 dark:text-gray-500 uppercase tracking-wide">{formatDate(issue_date)}</p>
            </div>
        </GlassCard>
    );
};

export default CertificationCard;
